import { FiAlertTriangle, FiX, FiTrash2 } from "react-icons/fi";
import { FaSpinner } from "react-icons/fa";

export default function DeleteConfirmModal({
  order,
  isDeleting,
  onConfirm,
  onCancel,
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm bg-white rounded-[18px] overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="px-6 py-5 flex items-center justify-between border-b border-[#edf1f7]">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center">
              <FiAlertTriangle className="text-red-500 text-[16px]" />
            </div>
            <h2 className="text-[17px] font-bold text-[#111827]">
              Delete Order
            </h2>
          </div>
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="w-8 h-8 flex items-center bg-white border border-[#e5e7eb] justify-center rounded-full hover:bg-gray-100 text-[#6b7280] transition-colors disabled:opacity-50"
          >
            <FiX className="text-[15px]" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 py-6 space-y-4">
          <p className="text-[13px] text-[#4b5563]">
            Are you sure you want to delete this order?
          </p>

          {order && (
            <div className="bg-[#fef2f2] border border-red-100 rounded-xl px-4 py-3 space-y-1">
              {order.orderType && (
                <div className="flex items-center gap-2 text-[12px]">
                  <span className="text-[#9ca3af] w-24 shrink-0">
                    Order Type
                  </span>
                  <span className="font-semibold text-[#374151]">
                    {order.orderType}
                  </span>
                </div>
              )}
              {order.orderedBy && (
                <div className="flex items-center gap-2 text-[12px]">
                  <span className="text-[#9ca3af] w-24 shrink-0">
                    Ordered By
                  </span>
                  <span className="font-semibold text-[#374151]">
                    {order.orderedBy}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-[#edf1f7] flex justify-end gap-3 bg-[#fafbff]">
          <button
            onClick={onCancel}
            disabled={isDeleting}
            className="px-5 py-2 bg-white border border-[#e5e7eb] rounded-lg text-[13px] font-semibold text-[#374151] hover:bg-gray-50 transition-colors disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-5 py-2 rounded-lg bg-red-500 text-white text-[13px] font-semibold hover:bg-red-600 transition-colors flex items-center gap-2 disabled:opacity-60 shadow-sm"
          >
            {isDeleting ? (
              <FaSpinner className="animate-spin text-[13px]" />
            ) : (
              <FiTrash2 className="text-[13px]" />
            )}
            {isDeleting ? "Deleting\u2026" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
